"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiRequest = apiRequest;

var _effects = require("redux-saga/effects");

var _config = require("../../../config");

var _selectors = require("../../auth/selectors");

var _errorHandler = require("./errorHandler");

var _selectors2 = require("../authRefresh/selectors");

var refreshTypes = _interopRequireWildcard(require("../authRefresh/types"));

var _actions = require("../authRefresh/actions");

var _errorCodes = require("../../../constants/errorCodes");

var _selectors3 = require("../../partnerEmulation/selectors");

var _Utils = _interopRequireDefault(require("../../../utils/Utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(apiRequest);

var TIMEOUT = 120000;

function apiRequest(endpoint) {
  var method,
      params,
      signal,
      isNeedToken,
      accessToken,
      refreshIsFetching,
      _ref,
      refreshFailure,
      tokenType,
      headers,
      emulationPartnerId,
      options,
      url,
      baseApiUrl,
      queryString,
      timeout,
      response,
      requestTimeout,
      error,
      result,
      isJsonResponse,
      currentAccessToken,
      _args = arguments;

  return regeneratorRuntime.wrap(function apiRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          method = _args.length > 1 && _args[1] !== undefined ? _args[1] : "GET";
          params = _args.length > 2 ? _args[2] : undefined;
          signal = _args.length > 3 ? _args[3] : undefined;
          isNeedToken = !(params && params.auth === false);
          _context.next = 6;
          return (0, _effects.select)(_selectors.getAccessToken);

        case 6:
          accessToken = _context.sent;

          if (!isNeedToken) {
            _context.next = 24;
            break;
          }

          if (accessToken) {
            _context.next = 12;
            break;
          }

          _context.next = 11;
          return (0, _effects.call)(_errorHandler.errorHandler, {
            code: _errorCodes.ERROR_CODES.NO_AUTH_TOKEN_EXISTS,
            message: 'Forbidden'
          }, endpoint, method, params);

        case 11:
          return _context.abrupt("return", _context.sent);

        case 12:
          _context.next = 14;
          return (0, _effects.select)(_selectors2.getIsFetching);

        case 14:
          refreshIsFetching = _context.sent;

          if (!refreshIsFetching) {
            _context.next = 24;
            break;
          }

          _context.next = 18;
          return (0, _effects.race)({
            refreshFailure: (0, _effects.take)(refreshTypes.FAILURE),
            refreshSuccess: (0, _effects.take)(refreshTypes.SUCCESS)
          });

        case 18:
          _ref = _context.sent;
          refreshFailure = _ref.refreshFailure;

          if (!refreshFailure) {
            _context.next = 24;
            break;
          }

          _context.next = 23;
          return (0, _effects.call)(_errorHandler.errorHandler, {
            code: _errorCodes.ERROR_CODES.REFRESH_FAILURE,
            message: 'Forbidden'
          }, endpoint, method, params);

        case 23:
          return _context.abrupt("return", _context.sent);

        case 24:
          _context.next = 26;
          return (0, _effects.select)(_selectors.getTokenType);

        case 26:
          tokenType = _context.sent;
          _context.next = 29;
          return (0, _effects.select)(_selectors.getAccessToken);

        case 29:
          accessToken = _context.sent;
          headers = {
            'accept': 'application/json, text/plain, */*'
          };

          if (isNeedToken) {
            headers['Authorization'] = "".concat(tokenType, " ").concat(accessToken);
          }

          if (params && params.locale) {
            headers['Request-locale'] = params.locale;
          } // Set emulation partner header


          _context.next = 35;
          return (0, _effects.select)(_selectors3.getEmulationPartnerId);

        case 35:
          emulationPartnerId = _context.sent;

          if (emulationPartnerId) {
            headers['emulationPartnerId'] = emulationPartnerId;
          } // TODO: check where it was used
          // Copy endpoint params to query
          // const endpointParts = endpoint.split("?");
          // if(endpointParts.length > 1){
          //     const endpointParams = new URLSearchParams(endpointParts[1]);
          //     for (let p of endpointParams) {
          //         params.body[p[0]] = p[1];
          //     }
          // }
          //
          // const endpointUrl = endpointParts[0];


          options = {
            method: method,
            headers: headers,
            signal: signal
          };

          if (params && params.formData) {
            options.body = params.formData;
          } else {
            headers['Content-Type'] = 'application/json';
            options.body = params && params.body ? _Utils["default"].buildBodyString(params.body) : undefined;
          }

          baseApiUrl = _config.Config.get('settings', 'apiBaseUrl');

          if (method === 'GET') {
            queryString = params.query ? _Utils["default"].buildQueryString(params.query) : '';
            url = "".concat(baseApiUrl).concat(endpoint).concat(queryString);
          } else {
            url = "".concat(baseApiUrl).concat(endpoint);
          }

          requestTimeout = params.hasOwnProperty('timeout') ? params.timeout : TIMEOUT;
          _context.prev = 42;

          if (!(requestTimeout > 0)) {
            _context.next = 51;
            break;
          }

          _context.next = 46;
          return (0, _effects.race)({
            timeout: (0, _effects.delay)(TIMEOUT),
            response: (0, _effects.call)(fetch, url, options)
          });

        case 46:
          result = _context.sent;
          timeout = result.timeout;
          response = result.response;
          _context.next = 54;
          break;

        case 51:
          _context.next = 53;
          return (0, _effects.call)(fetch, url, options);

        case 53:
          response = _context.sent;

        case 54:
          isJsonResponse = response && response.headers && response.headers.get("Content-Type") && response.headers.get("Content-Type").indexOf("application/json") !== -1;

          if (!timeout) {
            _context.next = 59;
            break;
          }

          error = {
            code: _errorCodes.ERROR_CODES.TIMEOUT,
            message: 'There was a problem with your request. Please try again later.'
          };
          _context.next = 95;
          break;

        case 59:
          if (!(response.status === 200)) {
            _context.next = 69;
            break;
          }

          if (!isJsonResponse) {
            _context.next = 66;
            break;
          }

          _context.next = 63;
          return (0, _effects.call)([response, 'json']);

        case 63:
          return _context.abrupt("return", _context.sent);

        case 66:
          return _context.abrupt("return", response);

        case 67:
          _context.next = 95;
          break;

        case 69:
          if (![0, 404, 502].includes(response.status)) {
            _context.next = 73;
            break;
          }

          error = {
            code: _errorCodes.ERROR_CODES.HTTP_ERROR,
            message: response.status.toString()
          };
          _context.next = 95;
          break;

        case 73:
          if (!(signal && signal.aborted)) {
            _context.next = 77;
            break;
          }

          error = {
            code: _errorCodes.ERROR_CODES.ABORT,
            message: method + ' request to `' + url + '` is aborted!'
          };
          _context.next = 95;
          break;

        case 77:
          if (!isJsonResponse) {
            _context.next = 93;
            break;
          }

          _context.next = 80;
          return (0, _effects.call)([response, 'json']);

        case 80:
          error = _context.sent;

          if (![_errorCodes.ERROR_CODES.ACCESS_TOKEN_EXPIRED, _errorCodes.ERROR_CODES.INVALID_ACCESS_TOKEN].includes(error.code)) {
            _context.next = 91;
            break;
          }

          _context.next = 84;
          return (0, _effects.select)(_selectors.getAccessToken);

        case 84:
          currentAccessToken = _context.sent;
          _context.next = 87;
          return (0, _effects.select)(_selectors2.getIsFetching);

        case 87:
          refreshIsFetching = _context.sent;

          if (!(accessToken === currentAccessToken && !refreshIsFetching)) {
            _context.next = 91;
            break;
          }

          _context.next = 91;
          return (0, _effects.put)((0, _actions.saga)());

        case 91:
          _context.next = 95;
          break;

        case 93:
          error = {
            code: _errorCodes.ERROR_CODES.UNKNOWN_ERROR,
            message: response.statusText
          };

          if ([401].includes(response.status)) {
            error.code = _errorCodes.ERROR_CODES.ACCESS_FORBIDDEN;
          }

        case 95:
          _context.next = 100;
          break;

        case 97:
          _context.prev = 97;
          _context.t0 = _context["catch"](42);

          if (_context.t0.message === "The user aborted a request.") {
            error = {
              code: _errorCodes.ERROR_CODES.ABORT,
              message: method + ' request to `' + url + '` is aborted!'
            };
          } else {
            error = {
              code: _errorCodes.ERROR_CODES.UNKNOWN_ERROR,
              message: _context.t0.message
            };
          }

        case 100:
          _context.next = 102;
          return (0, _effects.call)(_errorHandler.errorHandler, error, endpoint, method, params);

        case 102:
          return _context.abrupt("return", _context.sent);

        case 103:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[42, 97]]);
}